import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from 'common/helpers/loadingStatus';

export const STATE_NAME = 'addressAutocomplete';

const INITIAL_STATE = {
    options: [],
    selectedOption: null,
    autocompletedAddress: null,
    autocompletedValue: null,

    loadingStatus: LOADING_STATUSES.BLANK,
    error: null,
};

// Actions
export const setInputValue = createAction(`${STATE_NAME}/setInputValue`);

// Events
export const searchPending = createAction(`${STATE_NAME}/searchPending`);
export const searchFulfilled = createAction(`${STATE_NAME}/searchFulfilled`);
export const searchRejected = createAction(`${STATE_NAME}searchRejected`);

export const autocompletePending = createAction(
    `${STATE_NAME}/autocompletePending`,
);
export const autocompleteFulfilled = createAction(
    `${STATE_NAME}/autocompleteFulfilled`,
);
export const autocompleteRejected = createAction(
    `${STATE_NAME}autocompleteRejected`,
);

const addressAutocompleteSlice = createSlice({
    name: STATE_NAME,
    initialState: INITIAL_STATE,
    reducers: {
        reset: () => ({ ...INITIAL_STATE }),
        setOptions: (state, { payload }) => {
            state.options = payload;
        },
        setSelectedOption: (state, { payload: { selectedOption } }) => {
            state.selectedOption = selectedOption;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(searchPending, state => ({
                ...state,
                loadingStatus: LOADING_STATUSES.PENDING,
            }))
            .addCase(searchFulfilled, (state, { payload }) => ({
                ...state,
                loadingStatus: LOADING_STATUSES.IDLE,
                error: null,
                options: payload,
            }))
            .addCase(searchRejected, (state, { payload }) => ({
                ...state,
                loadingStatus: LOADING_STATUSES.IDLE,
                error: payload.message,
            }));

        builder
            .addCase(autocompletePending, state => ({
                ...state,
                loadingStatus: LOADING_STATUSES.PENDING,
            }))
            .addCase(autocompleteFulfilled, (state, { payload }) => ({
                ...state,
                loadingStatus: LOADING_STATUSES.IDLE,
                error: null,
                autocompletedAddress: payload.autocompletedAddress,
                autocompletedValue: payload.autocompletedValue,
            }))
            .addCase(autocompleteRejected, (state, { payload }) => ({
                ...state,
                loadingStatus: LOADING_STATUSES.IDLE,
                error: payload.message,
            }));
    },
});

export const { reset, setOptions, setSelectedOption } =
    addressAutocompleteSlice.actions;

export const selectAddressAutocomplete = state => state[STATE_NAME];

export const selectStatus = createSelector(
    selectAddressAutocomplete,
    state => ({
        isLoading: state.loadingStatus === LOADING_STATUSES.PENDING,
        isError:
            state.loadingStatus === LOADING_STATUSES.IDLE &&
            Boolean(state.error),
        error: state.error,
    }),
);

export default addressAutocompleteSlice.reducer;
